package com.essntl.features.tag.ui.addedittag

import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.State
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.getData
import com.essntl.features.tag.domain.model.TagModel
import com.essntl.features.tag.domain.repository.TagRepository
import com.essntl.toastmanager.ToastManager
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update

class AddEditTagViewModel(
    private val tagRepository: TagRepository,
    private val state: MutableStateFlow<AddEditTagState>,
    private val toastManager: ToastManager,
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
) : ViewModel {

    fun onEvent(event: AddEditTagEvent) {
        when (event) {
            is AddEditTagEvent.GetTag -> getTag(event)
            is AddEditTagEvent.UpdateTagFields -> updateTagFields(event)
            is AddEditTagEvent.EditTag -> editTag()
            is AddEditTagEvent.DeleteTag -> deleteTag()
            is AddEditTagEvent.ClearState -> clearState()
        }
    }

    private var getTagJob: Job? = null
    private fun getTag(event: AddEditTagEvent.GetTag) {
        getTagJob?.cancel()
        getTagJob = getData(
            getData = { tagRepository.get(event.id) },
            getState = { state.value.getTag },
            setState = {
                state.value = state.value.copy(
                    getTag = it,
                    isEditEnabled = false,
                )
            },
            onSuccess = { t ->
                state.value.tag.value = t
            },
        )
    }

    private fun updateTagFields(event: AddEditTagEvent.UpdateTagFields) {
        state.value.tag.value = event.tag
        val newTag =
            state.value.getTag.data?.getChangedFields(state.value.tag.value) ?: return
        state.update {
            it.copy(isEditEnabled = !newTag.isEmpty)
        }
    }

    private fun editTag() =
        getData(
            getData = { tagRepository.update(state.value.tag.value) },
            getState = { state.value.addEditTag },
            setState = { state.value = state.value.copy(addEditTag = it) },
            onSuccess = { ta ->
                state.update {
                    it.copy(
                        getTag = State.success(ta),
                    )
                }

                state.value.tag.value = ta

                toastManager.success(
                    description = "Tag updated successfully",
                )
            },
        )

    private fun deleteTag() =
        getData(
            getData = { tagRepository.delete(state.value.tag.value) },
            getState = { state.value.deleteTag },
            setState = { state.value = state.value.copy(deleteTag = it) },
            onSuccess = {
                toastManager.success(
                    description = "Tag deleted successfully",
                )
            },
        )

    private fun clearState() {
        state.value = state.value.copy(
            getTag = State(),
            addEditTag = State(),
            deleteTag = State(),
            isEditEnabled = false,
        )
        state.value.tag.value = TagModel.empty
    }
}